var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/propose-unapproved-detail.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-0b8a348e!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/propose-unapproved-detail.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProposeUnapprovedDetail.vue
// module id = 691
// module chunks = 1